/*
  { 
    title: "",
    writers: "",
    conference: "",
    publicationDate: "",
    doi: "",
    link: "",
    type: "conference" 
  },
  { 
    title: "",
    writers: "",
    conference: "",
    publicationDate: "",
    doi: "",
    link: "",
    type: "journal" 
  },
  { 
    title: "",
    writers: "",
    conference: "",
    publicationDate: "",
    doi: "",
    link: "",
    type: "patent" 
  },
*/


export const publicationDetails = [
  { 
    title: "From Agentic to Autogenic Network Management for AI-Native 6G and Beyond: A Standards Perspective",
    writers: "P. Djukic, S. Acharya, T. E. Kennouche and B. Kantarci,",
    conference: "IEEE Network",
    publicationDate: "17 July 2026",
    doi: "https://doi.org/10.1109/MNET.2026.3711903",
    link: "https://doi.org/10.1109/MNET.2026.3711903",
    type: "journal" 
  },


  { 
    title: "Data-Driven Optimization of Truck–Drone Collaborative Delivery with Shared Fleet Allocation",
    writers: "C. Didem, M. Simsek, and B. Kantarci",
    conference: "Drones",
    publicationDate: "23 June 2026",
    doi: "https://doi.org/10.3390/drones10070476",
    link: "https://doi.org/10.3390/drones10070476",
    type: "journal" 
  },
  { 
    title: "A SOTIF-Oriented Framework for Safety Assessment in Autonomous Vehicles using Integrated Fault Tree and Bayesian Network Analysis, ",
    writers: "Dai, Lansu, and Burak Kantarci, ",
    conference: "ACM Journal on Autonomous Transportation Systems (2026), ",
    publicationDate: "17 April 2026",
    doi: "https://doi.org/10.1145/3810950",
    link: "https://doi.org/10.1145/3810950",
    type: "journal" 
  },
  
  { 
    title: "A Lightweight Digital-Twin-Based Framework for Edge-Assisted Vehicle Tracking and Collision Prediction, ",
    writers: "M. A. Onsu, P. Lohan, B. Kantarci, A. Syed, M. Andrews and S. Kennedy, ",
    conference: "IEEE International Conference on Communications (ICC) Workshops, Glasgow, United Kingdom, May 2026 (accepted).",
    publicationDate: "2026",
    doi: "https://arxiv.org/abs/2603.07338",
    link: "https://arxiv.org/abs/2603.07338",
    type: "conference" 
  },

  { 
    title: "UE Backpressure Defers EAS Creation, ",
    writers: "Chakraborty N., Kantarci B.,",
    conference: "Core Network Protocol technology filed as a European patent application (EP), Application No. 26155281.4, submitted on 30 January 2026 by Nokia Technologies Oy, ",
    publicationDate: "2025",
    doi: "",
    link: "",
    type: "patent" 
  },
  { 
    title: "Deep Fusion Intelligence: Enhancing 5G Security Against Over-the-Air Attacks, ",
    writers: "M. Amini, G. Asemian, B. Kantarci, and from a strong collaboration between SCVIC and thinkRF, ",
    conference: "IEEE Transactions on Machine Learning in Communications and Networking. ",
    publicationDate: "23 January 2025",
    doi: "https://doi.org/10.1109/TMLCN.2025.3533427",
    link: "https://ieeexplore.ieee.org/abstract/document/10851353",
    type: "patent" 
  },

  { 
    title: "FTA-NTN: Fairness and Throughput Assurance in Non-Terrestrial Networks, ",
    writers: "Trankatwar SR, Straulino H, Djukic P, Kantarci B., ",
    conference: "IEEE International Conference on Communications (ICC) 2026, ",
    publicationDate: "2026 (Accepted)",
    doi: "https://doi.org/10.48550/arXiv.2601.19078",
    link: "https://arxiv.org/abs/2601.19078",
    type: "conference" 
  },

  { 
    title: "Spatiotemporal Semantic V2X Framework for Cooperative Collision Prediction, ",
    writers: "Onsu MA, Lohan P, Kantarci B, Syed A, Andrews M, Kennedy S, ",
    conference: "EEE International Conference on Communications (ICC), ",
    publicationDate: "2026 (Accepted)",
    doi: "https://doi.org/10.48550/arXiv.2601.17216",
    link: "https://doi.org/10.48550/arXiv.2601.17216",
    type: "conference" 
  },
  { 
    title: "Intelligent Charging Reservation and Trip Planning of CAEVs and UAVs, ",
    writers: "Palwasha W. Shaikh , Hussein T. Mouftah and Burak Kantarci, ",
    conference: "Journal: Electronics, ",
    publicationDate: "2026",
    doi: "https://www.mdpi.com/2079-9292/15/2/440",
    link: "https://www.mdpi.com/2079-9292/15/2/440",
    type: "journal" 
  },
  { 
    title: "A Survey on Enhancing Autonomous Vehicle Safety through Fault Tree Analysis and SOTIF Integration, ",
    writers: "Dai, Lansu, and Burak Kantarci, ",
    conference: "ACM Journal on Autonomous Transportation Systems (2026), ",
    publicationDate: "2 January 2026",
    doi: "https://dl.acm.org/doi/10.1145/3787221",
    link: "https://dl.acm.org/doi/10.1145/3787221",
    type: "journal" 
  },
  { 
    title: "Semantic Edge–Cloud Communication for Real-Time Urban Traffic Surveillance with ViT and LLMs over Mobile Networks, ",
    writers: "M. A. Onsu; P. Lohan; B. Kantarci; A. Syed; M. Andrews; S. Kennedy, ",
    conference: "IEEE Transactions on Network Science and Engineering, ",
    publicationDate: "2025",
    doi: "https://doi.org/10.1109/TNSE.2025.3617881",
    link: "https://ieeexplore.ieee.org/document/11192791",
    type: "journal" 
  },
  { 
    title: "FLARE: Flying Learning Agents for Resource Efficiency in Next-Gen UAV Networks, ",
    writers: "X. Cai; P. Lohan; B. Kantarci, ",
    conference: "IEEE Networking Letters, ",
    publicationDate: "2025",
    doi: "https://doi.org/10.1109/LNET.2025.3611236",
    link: "https://ieeexplore.ieee.org/abstract/document/11168869",
    type: "journal" 
  },
  { 
    title: "Digital Twin Framework for Metamorphic Testing of Autonomous Driving Systems Using Generative Model, ",
    writers: "Y. Zhang, B. Kantarci, ",
    conference: "IEEE Globecom 2025, ",
    publicationDate: "2025",
    doi: "https://doi.org/10.48550/arXiv.2510.07133",
    link: "https://doi.org/10.48550/arXiv.2510.07133",
    type: "conference" 
  },

  { 
    title: "DT-DDNN: A Physical Layer Security Attack Detector in 5G RF Domain for CAVs, ",
    writers: "G. Asemian, M. Amini, B. Kantarci and M. Erol-Kantarci, ",
    conference: "",
    publicationDate: "IEEE Transactions on Vehicular Technology 20 August 2025, ",
    doi: "https://doi.org/10.1109/TVT.2025.3601032",
    link: "https://ieeexplore.ieee.org/document/11131477",
    type: "journal" 
  },
  { 
    title: "On-Dyn-CDA: A Real-Time Cost-Driven Task Offloading Algorithm for Vehicular Networks With Reduced Latency and Task Loss, " ,
    writers: "M. Paknejad, P. F. Moshiri, M. Simsek, B. Kantarci and H. T. Mouftah, ",
    conference: "",
    publicationDate: "IEEE Internet of Things Journal 25 August 2025 ",
    doi: "https://doi.org/10.1109/JIOT.2025.3602667",
    link: "https://ieeexplore.ieee.org/document/11141377",
    type: "journal" 
  },
  { 
    title: "Leveraging Edge Intelligence and LLMs to Advance 6G-Enabled Internet of Automated Defense Vehicles, ",
    writers: "M. A. Onsu, P. Lohan, B. Kantarci, ",
    conference: "",
    publicationDate: "IEEE Internet of Things Magazine, Vol. 8, Issue 4, July 2025",
    doi: "https://doi.org/10.1109/IOTM.001.2400162",
    link: "https://ieeexplore.ieee.org/document/11048765",
    type: "journal" 
  },
  { 
    title: "Machine Learning-Driven Truck-Drone Collaborative Delivery for Time- and Energy-Efficient Last-Mile Deliveries, ",
    writers: "D. Cicek, M. Simsek, B. Kantarci, ",
    conference: "",
    publicationDate: "MDPI Electronics 2025",
    doi: "https://doi.org/10.3390/electronics14102026",
    link: "https://www.mdpi.com/2079-9292/14/10/2026",
    type: "journal" 
  },
  { 
    title: "Leveraging Multimodal-LLMs Assisted by Instance Segmentation for Intelligent Traffic Monitoring, ",
    writers: "M. A. Onsu, P. Lohan, B. Kantarci, A. Syed, M. Andrews, S. Kennedy, ",
    conference: "30th IEEE Symposium on Computers and Communications (ISCC), ",
    publicationDate: "July 2025, Bologna, Italy",
    doi: "https://arxiv.org/abs/2502.11304",
    link: "https://arxiv.org/abs/2502.11304",
    type: "conference" 
  },
  { 
    title: "Advancing Autonomous Vehicle Safety: A Combined Fault Tree Analysis and Bayesian Network Approach, ",
    writers: "L. Dai, B. Kantarci, ",
    conference: "IEEE Intl. Conference on Engineering Reliable Autonomous Systems (ERAS), ",
    publicationDate: "May 2025",
    doi: "https://doi.org/10.1109/ERAS63351.2025.11135617",
    link: "https://doi.org/10.1109/ERAS63351.2025.11135617",
    type: "conference" 
  },
  { 
    title: "A Comparative Review of User Acceptance Factors for Drones and Sidewalk Robots in Autonomous Last Mile Delivery, ",
    writers: "D. Cicek, B. Kantarci, S. Schillo, ",
    conference: "",
    publicationDate: "Elsevier Green Energy and Intelligent Transportation, 2025",
    doi: "https://doi.org/10.1016/j.geits.2025.100310",
    link: "https://doi.org/10.1016/j.geits.2025.100310",
    type: "journal" 
  },

]


/*


  { 
    title: "Integrating Language Models for Enhanced Network State Monitoring in DRL-Based SFC Provisioning,",
    writers: "P. Fard Moshiri, M. A. Onsu, P. Lohan, B. Kantarci, E. Janulewicz, ",
    conference: "30th IEEE Symposium on Computers and Communications (ISCC), ",
    publicationDate: "July 2025, Bologna, Italy",
    doi: "https://arxiv.org/abs/2502.11298",
    link: "https://arxiv.org/abs/2502.11298",
    type: "conference" 
  },


  
*/ 